module.exports = __webpack_public_path__ + "static/media/antano-choclo-maiz-y-queso-320g-1920x1080.7074091a.webp";